<div class="search-container">
  <div class="search-wrapper">
    <div class="search-field inline-block align-top w-full" [ngStyle]="{ 'max-width': maxWidth }" [ngClass]="{ 'search-mobile': mobileSearch }">
      <mat-form-field appearance="outline" color="primary" class="w-full" [attr.data-test-id]="attrDataTestId">
        <input type="text" [(ngModel)]="searchText" matInput autocomplete="off" (input)="onKeyUp(searchText)" [placeholder]="placeholder" (keydown.enter)="addOnEnter.emit()" />
        <mat-icon *ngIf="!searchText" matSuffix class="cursor-pointer">search</mat-icon>
        <button mat-icon-button *ngIf="searchText" (click)="clearSearch()" matSuffix class="clear-button cursor-pointer"><mat-icon>clear</mat-icon></button>
      </mat-form-field>
    </div>

    <div class="search-button" [ngClass]="{ 'search-mobile': mobileSearch }">
      <button mat-flat-button class="button-primary" (click)="toggleSearch()">
        <mat-icon class="material-icons-outlined">search</mat-icon>
        Search
      </button>
    </div>
  </div>
</div>
